/**
 * Registriert Rollup WebComponents
 * E018-S008-T009
 */
import { RollupConfigMenu } from './rollup-config-menu';

export function registerRollupEffects() {
  if (!customElements.get('rollup-config-menu')) {
    customElements.define('rollup-config-menu', RollupConfigMenu);
  }
}

// Auto-register
registerRollupEffects();
